<template>
    <div class="element-generic-error" v-if="error">
        <p>{{error}}</p>
    </div>
</template>
<script type = "text/javascript">
    export default {
        props: {
            error: String,
        }
    }
</script>
